import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import AppEnvironment from './environment/app-environment';

void i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    // debug: true,
    load: 'currentOnly',
    fallbackLng: 'en-US',
    backend: {
      loadPath: `${AppEnvironment.publicUrl}/locales/{{lng}}/{{ns}}.json`,
    },
  });

export default i18next;
